'use client';

import type { GetCouponsServiceResponse } from '@musinsa/services-curator';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { curatorQueries } from '../../query-factory';

interface UseCouponListParams {
  shopTitle: string;
  enabled?: boolean;
}

export const useCouponList = ({ shopTitle, enabled = true }: UseCouponListParams) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isSuccess, isError } =
    useInfiniteQuery({
      ...curatorQueries.coupon.list(shopTitle),
      initialPageParam: 1,
      getNextPageParam: (lastPage: GetCouponsServiceResponse) =>
        lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
      enabled: !!shopTitle && enabled,
    });

  const coupons = useMemo(() => data?.pages.flatMap((page) => page.list) ?? [], [data]);

  return {
    coupons,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isSuccess,
    isError,
  };
};
